<template>
  <div class="view-container">
    <div class="content">
    <h3>Recover account.</h3>
    <form name="recover" class="form-horizontal recover" role="form" data-toggle="validator">
        <div class="row form-group">
            <label class="form-control-label col-xs-12">Email address</label>
            <div class="input-group col-xs-12">
                <span class="input-group-addon"><i class="fa fa-envelope fa-fw"></i></span>
                <input type="email" name="EmailAddress" class="form-control" data-error="An email address must be supplied." required />
            </div>
            <div class="help-block with-errors"></div>
        </div>
        <div class="row form-group">
            <button type="submit" name="Recover" class="btn btn-success">Recover</button>
        </div>
    </form>
</div>
  </div>
</template>
<!-- Scripts -->
<script>
import { view } from "./Recover.vue.js";
export default {
  name: "Recover",
  components: {
  },
  mixins: [view],
  data() {
    return {}
  },
  created() {
  },
  mounted() {
    document.querySelector('form[name=recover]').addEventListener("submit", this.submit);
  }
};
</script>
